var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBronzeBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8281 15.4625H19.2256L27.2231 0H20.8256L12.8281 15.4625Z",
    fill: "#006CA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8264 7.7301L13.6289 13.9176L14.4289 15.4626H19.2264L20.0264 13.9176L16.8264 7.7301Z",
    fill: "#101010"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7358 19.195H13.3383V15.4625H19.7358V19.195ZM19.7358 13.8625H13.3383C12.9139 13.8625 12.507 14.0311 12.2069 14.3312C11.9069 14.6312 11.7383 15.0382 11.7383 15.4625V19.195C11.7383 20.08 12.4533 20.795 13.3383 20.795H19.7358C20.6208 20.795 21.3358 20.08 21.3358 19.195V15.4625C21.3358 14.5775 20.6208 13.8625 19.7358 13.8625Z",
    fill: "#F79329"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.536 23.9925C24.536 28.41 20.956 31.99 16.5385 31.99C12.121 31.99 8.54102 28.41 8.54102 23.9925C8.54102 19.575 12.121 15.995 16.5385 15.995C20.956 15.995 24.536 19.5775 24.536 23.9925Z",
    fill: "#F79329"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1756 22.0476C11.0706 22.0476 10.9656 22.0276 10.8656 21.9826C10.4806 21.8176 10.2956 21.3701 10.4456 20.9801C10.4481 20.9726 10.4506 20.9676 10.4531 20.9626C10.4556 20.9501 10.4556 20.9526 10.4631 20.9426C10.8131 20.1111 11.3555 19.3745 12.0456 18.7934C12.7358 18.2123 13.554 17.8034 14.4331 17.6001C14.5206 17.5801 14.6131 17.6226 14.6531 17.7051C14.6931 17.7876 14.6706 17.8876 14.5981 17.9451C13.4306 18.8726 12.4981 20.1251 11.9006 21.5626C11.9006 21.5651 11.8981 21.5676 11.8981 21.5676C11.8981 21.5701 11.8981 21.5701 11.8956 21.5726C11.8131 21.7651 11.6606 21.9151 11.4656 21.9901C11.3731 22.0301 11.2731 22.0476 11.1756 22.0476Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7583 15.4625H13.3608L5.36328 0H11.7608L19.7583 15.4625Z",
    fill: "#006CA2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeBadge);
export default __webpack_public_path__ + "static/media/bronze-badge.b7247e971b99767b15896158b6f93dc1.svg";
export { ForwardRef as ReactComponent };